import _ from 'lodash';

// Buffer requests to prevent consuming the entire rate limit.
// https://docs.sentry.io/clients/javascript/config/

const ERROR_LIMIT = 10;
let ravenErrorBuffer = {};

function shouldSendError(errorKey) {
  if (typeof ravenErrorBuffer[errorKey] == 'number') {
    ravenErrorBuffer[errorKey]++;
  } else {
    ravenErrorBuffer[errorKey] = 1;
  }

  return (ravenErrorBuffer[errorKey] < ERROR_LIMIT);
}

export default function sentryConfigWithFilters (sentryConfig) {
  return _.extend(sentryConfig, {
    shouldSendCallback: function (data) {
      return shouldSendError(data.message || data.exception.values[0].value);
    }
  });
};



// WEBPACK FOOTER //
// ./source/client/sentry-filter.js